import { Component, OnInit, Output, EventEmitter, Input, AfterViewInit } from '@angular/core';
import { CompanyService } from '../../services/company-service/company.service';


@Component({
  selector: 'company-select',
  templateUrl: './company-selector.component.html',
  styleUrls: ['./company-selector.component.css']
})
export class CompanySelectorComponent implements OnInit, AfterViewInit {




  companies = new Array<any>();

  selectedCompany;
  companyid: number = -1;

  selectedLocation;
  locationid: number = -1;
  valid: boolean = false;

  departments;
  selectedDepartment;
  departmentid;



  @Output() locationSelected: EventEmitter<any> = new EventEmitter();
  @Output() companySelected: EventEmitter<any> = new EventEmitter();
  @Output() invalidCompanyCombination: EventEmitter<any> = new EventEmitter();
  @Input() options: CompanyLocationSelectorOptions;
  @Input() emptyOptionLabel = 'Select Company';

  constructor(private companyService: CompanyService) {


  }

  ngOnInit() {
    this.onGetCompanies();
  }

  ngAfterViewInit(): void {
    this.options;
  }


  reset() {

  }

  onGetCompanies() {

    this.companyService.getCompany().then((res: any) => {
      if (res.status) {
        this.companies = res.data;
      } else {
        alert("Could not get companies: " + res.message);
      }
    }).catch(e => {
      alert("Could not get companies: " + e);
    });
  }

  onDepartmentSelected(value) {
    this.departmentid = value;
    this.selectedDepartment = this.departments.find(d => d.id == this.departmentid);
    console.log(this.selectedDepartment);
    console.log(this.departmentid);
  }

  onCompanySelected(id) {
    this.invalidCompanyCombination.emit({});
    this.companyid = id;
    this.locationid = -1;
    this.selectedLocation = null;
    this.valid = false;
    if (id != -1) {
      this.selectedCompany = this.companies.find(x => x.id == this.companyid);
      this.companySelected.emit({
        companyid: this.selectedCompany.id,
        locations: this.selectedCompany.locations
      });
    } else {
      this.companySelected.emit({
        companyid: null
      });
    }
  }

  onLocationSelected(id) {
    this.invalidCompanyCombination.emit({});
    this.locationid = id;
    if (id != -1) {
      this.selectedLocation = this.selectedCompany.locations.find(x => x.id == id);
      this.locationSelected.emit({
        companyid: this.selectedCompany.id,
        locationid: this.selectedLocation.id
      });
      this.valid = true;
      if (this.options.showDepartments) {
        this.companyService.getDepartments(this.companyid, this.locationid).then((res: any) => {
          if (res.status) {
            this.departments = res.data;
          } else {
            alert("Unable to get departments for company location:" + res.message);
          }
        }).catch(e => {
          alert("Unable to get departments for company location:" + e);
        })
      }
    } else {
      this.valid = false;
    }
  }

}

export interface CompanyLocationSelectorOptions {
  style?: {}
  class?: string,
  showDepartments?: boolean
}
